
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { ExtensionContentMonitor } from '@/services/analytics/ExtensionContentMonitor';

export const useExtensionContentMonitoring = () => {
  const { user } = useAuth();

  useEffect(() => {
    const monitor = ExtensionContentMonitor.getInstance();
    
    if (user) {
      console.log('[Extension Monitoring Hook] Starting extension content monitoring for user:', user.id);
      monitor.startMonitoring(user);
    }

    return () => {
      monitor.stopMonitoring();
    };
  }, [user]);
};
